const contactForm = {

  init: () => {

    const form = document.getElementById('contact-form');
    if (!form) return;
    contactForm.addEventListener(form);

  },

  addEventListener: (form) => {
    form.addEventListener("submit", contactFormSubmission);
  },

  removeEventListener: () => {
    const form = document.getElementById('contact-form');
    if (!form) return;
    form.removeEventListener("submit", contactFormSubmission);
  }


}

const submitForm = {

  init: () => {

    const form = document.getElementById('submit-form');
    if (!form) return;
    submitForm.addEventListener(form);

  },

  addEventListener: (form) => {
    form.addEventListener("submit", submitFormSubmission);
  },

  removeEventListener: () => {
    const form = document.getElementById('submit-form');
    if (!form) return;
    form.removeEventListener("submit", submitFormSubmission);
  }


}

function contactFormSubmission() {

  event.preventDefault();
  var form = event.target;
  var data = new FormData(form);
  var btn = form.querySelector('button');
  var request = new XMLHttpRequest();

  request.onreadystatechange = function(){
    var successMessage = form.querySelector(".submit-message-success");
    var successMessage = form.querySelector(".submit-message-error");
    btn.innerText = 'Sending';
    if (request.readyState == 4) {
      //request finished
       if (request.status === 200) {
        //success  
        successMessage.classList.remove('hidden');
        // setTimeout(function() {
          btn.innerText = 'Sent';
          successMessage.classList.add('hidden');
        // }, 2000);
      } else {  
        //error
        console.log("Error", request.statusText); 
        btn.innerText = 'Error';
        successMessage.classList.remove('hidden'); 
      }  
    }
  }

  request.open(form.method, form.action)
  request.send(data)
  //prevent double submission
  return false;

}

function submitFormSubmission() {

  event.preventDefault();
  var form = event.target;
  var data = new FormData(form);
  var btn = form.querySelector('button');
  var request = new XMLHttpRequest();

  request.onreadystatechange = function(){
    var successMessage = form.querySelector(".submit-message-success");
    var successMessage = form.querySelector(".submit-message-error");
    btn.innerText = 'Sending';
    if (request.readyState == 4) {
      //request finished
       if (request.status === 200) {
        //success  
        successMessage.classList.remove('hidden');
        // setTimeout(function() {
          btn.innerText = 'Sent';
          successMessage.classList.add('hidden');
        // }, 2000);
      } else {  
        //error
        console.log("Error", request.statusText); 
        btn.innerText = 'Error';
        successMessage.classList.remove('hidden'); 
      }  
    }
  }

  request.open(form.method, form.action)
  request.send(data)
  //prevent double submission
  return false;

}

export {contactForm, submitForm}


